import gql from 'graphql-tag';

const CREATE_SALES_TRIAL_LESSON = gql`
  mutation createSalesTrialLesson($page_url: String!, $code: String!, $email: String!) {
    createSalesTrialLesson(page_url: $page_url, code: $code, email: $email) {
      id
      url_student_a
      url_student_b
      from
      to
    }
  }
`;

export { CREATE_SALES_TRIAL_LESSON };
